/**
 * Formats a duration in seconds into a coarse, human-readable string
 * (e.g. `90` → `"2 minutes"`, `3600` → `"1 hour"`). Returns `"-"` for
 * non-finite / invalid input.
 *
 * Relocated to the shared utils layer (modularization) so cross-feature
 * consumers (job-stage actions) stop importing into the reports page layer.
 */
export const secondsToHumanTime = (data: number) => {
  if (!data || !isFinite(data) || isNaN(data)) {
    return '-';
  }

  const totalSeconds = Math.round(data);

  const DAY_IN_SECONDS = 24 * 60 * 60;
  const HOUR_IN_SECONDS = 60 * 60;
  const MINUTE_IN_SECONDS = 60;

  if (totalSeconds >= DAY_IN_SECONDS) {
    const days = Math.round(totalSeconds / DAY_IN_SECONDS);
    return `${days} day${days !== 1 ? 's' : ''}`;
  } else if (totalSeconds >= HOUR_IN_SECONDS) {
    const hours = Math.round(totalSeconds / HOUR_IN_SECONDS);
    return `${hours} hour${hours !== 1 ? 's' : ''}`;
  } else if (totalSeconds >= MINUTE_IN_SECONDS) {
    const minutes = Math.round(totalSeconds / MINUTE_IN_SECONDS);
    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  } else {
    return `${totalSeconds} second${totalSeconds !== 1 ? 's' : ''}`;
  }
};
